export default {
	props: {
		'yearsBack': {
			type: Number,
			default: 100
		},
		'yearsForward': {
			type: Number,
			default: 10
		},
		'min': {
			type: String,
			default: null
		},
		'max': {
			type: String,
			default: null
		},
	},
}
